import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  timeout: 60000, // Increased to 60 seconds to handle cloud DB latency
});

// Request Interceptor for adding Auth Token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor for Global Error Handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    
    if (response) {
      // Server-side errors
      if (response.status === 401) {
        // Unauthorized - Clear session only when a protected route is in play.
        const token = localStorage.getItem('token');
        const pathname = window.location?.pathname || '/';
        const isHomePage = pathname === '/';
        const isProtectedRoute = (
          pathname.startsWith('/profile') ||
          pathname.startsWith('/pro') ||
          pathname.startsWith('/dashboard') ||
          pathname.startsWith('/account') ||
          pathname.startsWith('/admin')
        );

        if (
          !isHomePage &&
          isProtectedRoute &&
          !pathname.includes('/signin') &&
          !pathname.includes('/checkout') &&
          token
        ) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/signin?expired=true';
        }
      } else if (response.status === 429) {
        console.error('Rate limit exceeded. Please wait.');
      }
    } else {
      // Network errors
      console.error('Network connection issues. Please check your internet.');
    }
    
    return Promise.reject(error);
  }
);

export default api;
